import React from "react";
import { FlatList, View, Text } from "react-native";
import { getOptionsStyles } from "../Options/styles";
import { ComboChoiceDisplay } from "@/app/selectors/options";
import { getLocalisedNumber, useTranslateText } from "@/app/utils/translations";

type ComboChoicesProps = {
  choices: ComboChoiceDisplay[];
  isBasketItemSelected: boolean;
};

const ComboChoices = ({
  choices,
  isBasketItemSelected,
}: ComboChoicesProps): JSX.Element => {
  const { locale } = useTranslateText();
  const styles = getOptionsStyles(isBasketItemSelected);

  return (
    <View style={styles.container}>
      <View style={styles.listContainer}>
        <FlatList
          keyExtractor={(item, index) => `${item.productId}-${index}`}
          data={choices}
          renderItem={({ item }) => (
            <Text style={styles.optionText}>
              {`${getLocalisedNumber(item.quantity, locale)}x ${item.name}`}
            </Text>
          )}
        />
      </View>
    </View>
  );
};

export default ComboChoices;
